import { useState } from 'react';
import { sendMessage, type Category, type Site } from '../lib/api.ts';

interface Props {
  readonly site: Site;
  readonly category: Category;
  readonly onSent: () => void;
}

/**
 * The target site and category are shown, not chosen. Filing from
 * inside the category is what makes routing correct at source -- there
 * is no dropdown to get wrong, and no supervisor recategorising all
 * day.
 */
export const Composer = ({ site, category, onSent }: Props) => {
  const [body, setBody] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const submit = async () => {
    const text = body.trim();
    if (!text) return;

    setBusy(true);
    setError('');
    try {
      await sendMessage({
        siteId: site.id,
        categoryId: category.id,
        body: text,
      });
      setBody('');
      onSent();
    } catch {
      setError('Could not send. Check your connection and try again.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="composer">
      {error && <p className="err">{error}</p>}
      <p className="mono">
        To {site.name} &middot; {category.name}
      </p>
      <textarea
        rows={3}
        value={body}
        placeholder={`Message ${site.name}...`}
        onChange={(e) => setBody(e.target.value)}
      />
      <button
        className="primary"
        disabled={busy || body.trim().length === 0}
        onClick={submit}
      >
        {busy ? 'Sending...' : 'Send'}
      </button>
    </div>
  );
};
